export const AUTHC_CUSTOM_WALLET = 'AUTHC_CUSTOM_WALLET'
